import React from 'react'
import SKILLS_DATA from '../../../data/SkillsData';


const Skills = () => {
    return (
        <div className=''>
            <h3 className='pb-2 text-lg font-semibold'>Tech Stack</h3>
            {SKILLS_DATA.map((skill, index) => (
                <div key={index}>
                    <h4 className='p-2 '>{skill.category}</h4>
                    <div className='flex flex-row'>
                        {skill.items.map((item, index) => (
                            <div key={index} className='flex items-center justify-center px-3 py-2 mx-1 rounded-md bg-darkTheme-bg-primary'>
                                <span className='text-darkTheme-accent-primary'>{item.icon}</span>
                                <span className='pl-1 text-sm'>{item.title}</span>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Skills